import { render, staticRenderFns } from "./SaveRole.vue?vue&type=template&id=5377842e"
import script from "./SaveRole.vue?vue&type=script&lang=js"
export * from "./SaveRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports